<img *ngIf="image" [src]="image.href" [alt]="image.alt"/>